import {
  Component,
  DestroyRef,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {
  Building,
  Business,
  Floor,
  ReservationsFiltersReportCreate,
  TypeOfJob,
  Workplace,
} from '../../../models';
import { BusinessService, ReservationService } from '../../../services';
import { WorkplaceTypeService } from '../../../services';
import { BuildingService } from '../../../services';
import { FloorService } from '../../../services';
import { ReportReservationsFiltersService } from '../../../services';
import { BussinesService } from '../../../../public/services';
import { WorkplaceService } from '../../../services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { ToastAlertService } from '@core/index';
import { Cookies } from 'typescript-cookie';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatMenu, MatMenuModule } from '@angular/material/menu';

@Component({
  templateUrl: './view-reservations-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    ButtonComponent,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatMenu,
    MatMenuModule,
  ],
})
export class ViewReservationsPageComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private formBuilder = inject(FormBuilder);
  private reservationService = inject(ReservationService);
  private alerService = inject(ToastAlertService);
  formReservation!: FormGroup;
  displayedColumns: string[] = [
    'initialDate',
    'finalDate',
    'checkinDate',
    'checkoutDate',
    'firstname',
    'email',
    'workstation',
    'jobType',
    'level',
    'building',
  ];
  dataSource: MatTableDataSource<any>;
  constructor(
    private workplacetype: WorkplaceTypeService,
    private building: BuildingService,
    private floor: FloorService,
    private ReservationFilters: ReportReservationsFiltersService,
    private business: BussinesService,
    private wokplace: WorkplaceService
  ) {
    this.dataSource = new MatTableDataSource();
    this.buildForm();
  }
  ngOnInit(): void {
    this.getBusiness();
    const business = Cookies.get('bussinesId');
    console.log('Validacion', business);
    if (business != null) {
      this.businessIdstate = parseInt(business.toString());
      this.selectedBussines = this.businessIdstate;
    } else {
      this.selectedBussines = -1;
      this.businessIdstate = null;
    }
    this.chargueDataForm();
  }
  chargueDataForm() {
    this.ObtenerPuestos();
    this.ObtenerEdificios();
  }
  ValidBusiness_id(): boolean {
    return this.businessIdstate === null;
  }
  ValidForms(): boolean {
    if (this.selectedBussines !== -1) {
      return true;
    } else {
      return false;
    }
  }

  private getBusiness() {
    this.businessServices
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
          }
        },
      });
  }
  puestos: TypeOfJob[] = [];
  edificios: Building[] = [];
  floors: Floor[] = [];

  private businessServices = inject(BusinessService);
  public selectedBussines = -1;
  public bussines: Business[] = [];
  private businessIdstate: number | null | undefined;
  formCompleted: boolean = false;
  private alertService = inject(ToastAlertService);
  private destroyRef = inject(DestroyRef);

  workplaces: Workplace[] = [];
  workplacesFilter = signal<Workplace[]>([]);

  realizarConsulta(): void {
    if (this.ValidForms()) {
      function formatDate(date: Date): string {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }

      const startDateObject = this.formReservation?.get('startDate')?.value;
      const endDateObject = this.formReservation?.get('endDate')?.value;

      let startDate = startDateObject;
      let endDate = endDateObject;

      console.log('Pre start', startDate);
      console.log('Pre End', endDate);

      if (startDateObject && endDateObject) {
        startDate = formatDate(startDateObject);
        endDate = formatDate(endDateObject);
      }

      let selectworkplacetype = this.formReservation?.get(
        'selectworkplacetype'
      )?.value;
      if (selectworkplacetype === -1) {
        selectworkplacetype = '';
      }
      let buildingId = this.formReservation?.get('buildingId')?.value;
      if (buildingId === -1) {
        buildingId = '';
      }
      let selectfloor = this.formReservation?.get('selectfloor')?.value;
      if (selectfloor === -1) {
        selectfloor = '';
      }

      let workplaceId = this.formReservation?.get('selectworkplace')?.value;
      if (workplaceId === -1) {
        workplaceId = '';
      }
      const username = this.formReservation?.get('username')?.value;
      const businessId = this.selectedBussines.toString();

      const formData: ReservationsFiltersReportCreate = {
        startDate: startDate,
        endDate: endDate,
        workplaceTypeId: selectworkplacetype,
        buildingId: buildingId,
        floorId: selectfloor,
        workplaceId: workplaceId,
        worker: username,
        businessId: businessId ? businessId : '',
        reservationStatusId: 1,
      };
      console.log('FORMDATA', formData);

      this.consultarReporte(formData);
    }
  }

  modalAction(action?: any) {
    console.log('Action', action);
    let width: string;
    if (window.innerWidth <= 768) {
      width = '90%';
    } else {
      width = '50%';
    }
    /*
    const dialogActionDetail = this.dialog.open(FloorCreateModalComponent, {
      width: width,
      data: {
        currentBuilding: this.currentBuilding,
        action: action,
      },
    });
    dialogActionDetail
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.loadFloors();
      });*/
  }

  consultarReporte(formData: ReservationsFiltersReportCreate): void {
    this.ReservationFilters.getReportReservationsFilters(formData).subscribe(
      data => {
        this.dataSource.data = data.reply.content;

        // Aplica ordenamiento
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      error => {
        console.error(error);
      }
    );
  }
  chargueFloorByBuilding(buldingid: number) {
    if (buldingid !== -1) {
      this.floors = [];
      this.floor.getFloorsByBuilding(buldingid).subscribe({
        next: resp => {
          if (resp.code === 10000) {
            const floor = {
              floorid: -1,
              name: '--',
              description: '',
              map: '',
              buildingid: -1,
              isParking: 1,
            };
            this.floors = [floor, ...resp.reply];
          } else {
            this.alerService.error(resp.detail);
          }
        },
      });
    }
  }

  clearForm() {
    this.buildForm();
  }

  ChargeworkplaceByFloor(floorId: number) {
    if (floorId !== -1) {
      //getkorkplace

      this.workplaces = [];
      this.wokplace.getkorkplace(floorId).subscribe({
        next: resp => {
          if (resp.code === 10000) {
            const workplace: Workplace = {
              workplaceid: -1,
              name: '--',
              code: -1,
              description: '',
              phone: '',
              x: -1,
              y: -1,
              status: -1,
              workplacetypeid: -1,
              roleid: -1,
              workplacegroupid: -1,
            };
            this.workplaces = [workplace, ...resp.reply];

            const type = this.formReservation?.get(
              'selectworkplacetype'
            )?.value;
            console.log('type', type);
            this.filterWorkplacesByTypeId(type);
          } else {
            this.alerService.error(resp.detail);
          }
        },
      });
    }
  }
  filterWorkplacesByTypeId(typeId: number) {
    console.log('Filtrando', typeId);
    if (typeId > 0) {
      console.log('True');
      this.workplacesFilter.set(
        this.workplaces.filter(
          workplace => workplace.workplacetypeid === typeId
        )
      );
    } else {
      console.log('False');
      this.workplacesFilter.set(this.workplaces);
    }
  }

  ObtenerPuestos() {
    if (this.selectedBussines !== -1) {
      this.workplacetype
        .getWorkplaces(this.selectedBussines)
        .subscribe(response => {
          if (response.status) {
            const typeOfJob = {
              workplacetypeid: -1,
              name: '--',
              description: '',
              recurrence: -1,
              maxcapacity: -1,
              isparking: '',
              blockstatus: -1,
              icon: '',
              color: '',
            };
            this.puestos = [typeOfJob, ...response.reply];
          } else {
            console.error('Error al obtener los puestos:', response.detail);
          }
        });
    }
  }

  ObtenerEdificios() {
    if (this.selectedBussines !== -1) {
      this.building.getBuildings(this.selectedBussines).subscribe(response => {
        if (response.status) {
          const buildingPredeter = {
            buildingid: -1,
            name: '--',
            code: '',
            address: '',
            city: '',
            country: '',
            country_id: -1,
            idBusiness: -1,
            latitude: -1,
            longitude: -1,
          };
          this.edificios = [buildingPredeter, ...response.reply];
        } else {
          console.error('Error al obtener los los edificios:', response.detail);
        }
      });
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  private buildForm() {
    this.formReservation = this.formBuilder.group({
      startDate: [''],
      jobType: [''],
      building: [''],
      level: [''],
      workstation: [''],
      username: [''],
      endDate: [''],
      selectworkplacetype: [''],
      buildingId: [''],
      selectfloor: [''],
      selectworkplace: [''],
    });
  }

  downloadPDF(): void {
    if (this.ValidForms()) {
      function formatDate(date: Date): string {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }

      const startDateObject = this.formReservation?.get('startDate')?.value;
      const endDateObject = this.formReservation?.get('endDate')?.value;

      let startDate = startDateObject;
      let endDate = endDateObject;
      if (startDateObject && endDateObject) {
        startDate = formatDate(startDateObject);
        endDate = formatDate(endDateObject);
      }

      let selectworkplacetype = this.formReservation?.get(
        'selectworkplacetype'
      )?.value;
      if (selectworkplacetype === -1) {
        selectworkplacetype = '';
      }
      let buildingId = this.formReservation?.get('buildingId')?.value;
      if (buildingId === -1) {
        buildingId = '';
      }
      let selectfloor = this.formReservation?.get('selectfloor')?.value;
      if (selectfloor === -1) {
        selectfloor = '';
      }

      let workplaceId = this.formReservation?.get('selectworkplace')?.value;
      if (workplaceId === -1) {
        workplaceId = '';
      }
      const username = this.formReservation?.get('username')?.value;
      const businessId = this.selectedBussines.toString();

      const formData: ReservationsFiltersReportCreate = {
        startDate: startDate,
        endDate: endDate,
        workplaceTypeId: selectworkplacetype,
        buildingId: buildingId,
        floorId: selectfloor,
        workplaceId: workplaceId,
        worker: username,
        businessId: businessId ? businessId : '',
        reservationStatusId: 1,
      };
      console.log(formData);

      this.consultarReportepdf(formData);
    }
  }
  consultarReportepdf(formData: ReservationsFiltersReportCreate): void {
    this.ReservationFilters.getReportReservationsFiltersPdf(formData).subscribe(
      (data: Blob) => {
        if (data.type == 'application/json') {
          this.alertService.warning('No hay datos para descargar.');
        } else {
          const file = new Blob([data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'reporte_reservas.pdf';
          link.click();
          window.URL.revokeObjectURL(url);
        }
      }
    );
  }
  downloadCsv() {
    if (this.ValidForms()) {
      function formatDate(date: Date): string {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }

      const startDateObject = this.formReservation?.get('startDate')?.value;
      const endDateObject = this.formReservation?.get('endDate')?.value;

      let startDate = startDateObject;
      let endDate = endDateObject;
      if (startDateObject && endDateObject) {
        startDate = formatDate(startDateObject);
        endDate = formatDate(endDateObject);
      }

      let selectworkplacetype = this.formReservation?.get(
        'selectworkplacetype'
      )?.value;
      if (selectworkplacetype === -1) {
        selectworkplacetype = '';
      }
      let buildingId = this.formReservation?.get('buildingId')?.value;
      if (buildingId === -1) {
        buildingId = '';
      }
      let selectfloor = this.formReservation?.get('selectfloor')?.value;
      if (selectfloor === -1) {
        selectfloor = '';
      }

      let workplaceId = this.formReservation?.get('selectworkplace')?.value;
      if (workplaceId === -1) {
        workplaceId = '';
      }
      const username = this.formReservation?.get('username')?.value;
      const businessId = this.selectedBussines.toString();

      const formData: ReservationsFiltersReportCreate = {
        startDate: startDate,
        endDate: endDate,
        workplaceTypeId: selectworkplacetype,
        buildingId: buildingId,
        floorId: selectfloor,
        workplaceId: workplaceId,
        worker: username,
        businessId: businessId ? businessId : '',
        reservationStatusId: 1,
      };
      console.log(formData);

      this.consultarReportecsv(formData);
    }
  }
  consultarReportecsv(formData: ReservationsFiltersReportCreate): void {
    this.ReservationFilters.getReportReservationsFiltersCsv(formData).subscribe(
      (data: Blob) => {
        if (data.type == 'application/json') {
          this.alertService.warning('No hay datos para descargar.');
        } else {
          const file = new Blob([data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'reporte_reservas.csv';
          link.click();
          window.URL.revokeObjectURL(url);
        }
      }
    );
  }
}
